<template>
  <!-- Navigation Bar-->
  <header id="topnav">
      <div class="topbar-main">
          <div class="container-fluid">

              <div class="logo">
                  <h3 class="logo-title">数字化施工平台</h3>
                  <a class="navbar-toggle nav-link">
                      <div class="lines">
                          <span></span>
                          <span></span>
                          <span></span>
                      </div>
                  </a>
              </div>


              <div class="menu-extras topbar-custom">

                  <ul class="list-unstyled topbar-right-menu float-right mb-0">
                      <li class="dropdown notification-list">
                        <a class="nav-link dropdown-toggle waves-effect nav-user el-dropdown-link color-picker" data-toggle="dropdown" href="#" role="button"
                           aria-haspopup="false" aria-expanded="false">
                           <el-color-picker v-model="pileColor" size="small" :predefine="predefineColors" @change="cancelColor"></el-color-picker>
                        </a>
                        <el-dropdown trigger="click">
                          <a class="nav-link dropdown-toggle waves-effect nav-user el-dropdown-link" data-toggle="dropdown" href="javascript:void(0)" role="button"
                             aria-haspopup="false" aria-expanded="false">
                              <span class="pro-user-name">{{username}}</span> <i class="el-icon-arrow-down el-icon--right"></i>
                          </a>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="toProfile"><i class="el-icon-user"></i>个人中心</el-dropdown-item>
                            <el-dropdown-item v-if="$can('car.manage')" @click.native="carManage"><i class="iconfont icon-zhuangji"></i>桩机管理</el-dropdown-item>
                            <el-dropdown-item v-if="$can('user.manage')" @click.native="userManage"><i class="iconfont icon-renyuan"></i>用户管理</el-dropdown-item>
                            <el-dropdown-item @click.native="Logout"><i class="iconfont icon-tuichu"></i>退出系统</el-dropdown-item>
                       <!--     <el-dropdown-item @click.native="logManage"><i class="iconfont el-icon-document"></i>日志管理</el-dropdown-item> -->
                          </el-dropdown-menu>
                        </el-dropdown>
                      </li>
                  </ul>
              </div>
              <!-- end menu-extras -->

              <div class="clearfix"></div>

          </div> <!-- end container -->
      </div>
      <!-- end topbar-main -->

      <div class="navbar-custom" :style="{ backgroundColor: pileColor }" >
          <div class="container-fluid">
              <div id="navigation">
                  <!-- Navigation Menu-->
                  <ul class="navigation-menu">
                    <li class="has-submenu" v-for="item in pathList">
                      <template v-if="item.pathChild.length > 0">
                        <a href="javascript:void(0)" :class="[pathArray.indexOf(item.pathTo) !== -1  ? 'parentMenu' : '']" ><i class="iconfont" :class="item.pathIcon"></i>{{item.pathName}}</a>
                        <ul class="submenu">
                          <li class="waves-effect" v-for="item2 in item.pathChild"><router-link :to="item2.pathTo" :class="[pathArray.indexOf(item2.pathTo) !== -1  ? 'childMenu' : '']">{{item2.pathName}}</router-link></li>
                        </ul>
                      </template>
                      <template v-else>
                        <router-link :to="item.pathTo" :class="[pathArray.indexOf(item.pathTo) !== -1  ? 'parentMenu' : '']"><i class="iconfont" :class="item.pathIcon"></i>{{item.pathName}}</router-link>
                      </template>
                    </li>
                  </ul>
                  <!-- End navigation menu -->
              </div> <!-- end #navigation -->
          </div> <!-- end container -->
      </div> <!-- end navbar-custom -->
  </header>
  <!-- End Navigation Bar-->
</template>

<script>
  import { applySkin } from '@/utils/skin.js'
  export default {
    name:'top',
    props:['pathArray'],
    data(){
      return{
        pathList:[{
          pathName: '位置监控',
          pathTo: '/monitor',
          pathIcon: 'icon-ditumap',
          pathChild: []
        },{
          pathName: '作业分析',
          pathTo: '/workAnalysis',
          pathIcon: 'icon-fenxi',
          pathChild: []
        },{
          pathName: '作业统计',
          pathTo: '/workStatistics',
          pathIcon: 'icon-shuju',
          pathChild: []
        },{
          pathName: '对比分析',
          pathTo: '/compareAnalysis',
          pathIcon: 'icon-duibi',
          pathChild: []
        }],
        pileColor:'#337537',
        predefineColors: ['#337537'],
        user:0,
		username:'',
      }
    },
    created(){
      let color = localStorage.getItem('pileColor');
      if(color){
        this.pileColor = color
      }
    },
    mounted() {
		//全端常显:移动端经汉堡菜单进入,不再按isM隐藏
		this.pathList.push({
			pathName: '上传作业',
			pathTo: '/uploadWork',
			pathIcon: 'icon-shangchuan',
			pathChild: []
		})
		this.username = JSON.parse(localStorage.getItem('pileUser')).username
    },
    methods:{
      //退出:保留pileAcc,记住密码需跨会话生效
      Logout(){
        localStorage.removeItem('pileToken');
        localStorage.removeItem('pilePerms');
        localStorage.removeItem('pileUser');
        this.$router.push({path:'/login'})
      },
      //个人中心
      toProfile(){
        this.$router.push({path:'/profile'})
      },
      cancelColor(e){
        //皮肤实时下发:写缓存并刷新全站覆盖样式
        if(e){
          localStorage.setItem('pileColor', e);
          applySkin(e);
        }
      },
      carManage(){
        this.$router.push({path:'/admin/zhuangji'})
      },
      userManage(){
        this.$router.push({path:'/admin/user'})
      },
      logManage(){
        this.$router.push({path:'/admin/log'})
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/header/index.vue